export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div>
        <h1 className="font-serif text-3xl sm:text-4xl text-white font-light">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1.5 text-sm">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, accent = false, sub }) {
  return (
    <div className={`rounded-2xl p-5 border ${accent ? "border-gold/25 bg-gradient-to-b from-gold/8 to-transparent" : "border-border bg-black/40"} hover-lift`} data-testid={`stat-${label.replace(/\s/g, "-").toLowerCase()}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs text-muted-foreground uppercase tracking-wider">{label}</span>
        {Icon && <Icon className="w-4 h-4 text-gold" />}
      </div>
      <div className="font-serif text-3xl text-white mt-3">{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, desc, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6" data-testid="empty-state">
      <div className="w-16 h-16 rounded-2xl glass flex items-center justify-center mb-5">
        {Icon && <Icon className="w-7 h-7 text-gold" />}
      </div>
      <h3 className="font-serif text-2xl text-white font-light">{title}</h3>
      {desc && <p className="text-muted-foreground mt-2 max-w-sm text-sm">{desc}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

const STATUS = {
  pending: ["Awaiting selection", "text-muted-foreground bg-white/5"],
  submitted: ["Selection submitted", "text-gold bg-gold/10 border border-gold/20"],
  approved: ["Approved", "text-emerald-400 bg-emerald-400/10 border border-emerald-400/20"],
  changes_requested: ["Changes requested", "text-orange-400 bg-orange-400/10 border border-orange-400/20"],
  active: ["Active", "text-emerald-400 bg-emerald-400/10 border border-emerald-400/20"],
  suspended: ["Suspended", "text-destructive bg-destructive/10 border border-destructive/20"],
};

export function StatusBadge({ status }) {
  const [label, cls] = STATUS[status] || [status, "text-muted-foreground bg-white/5"];
  return <span className={`text-[11px] px-2.5 py-1 rounded-full ${cls}`}>{label}</span>;
}
